import React from 'react';
import { LinkPreviewViewer } from '../viewer/link-preview-viewer.js';
import 'lodash';
import 'wix-rich-content-common';
import '../link-preview-d16f9cc2.js';
import 'wix-rich-content-plugin-html/libs/HtmlComponent';
import '../types.js';
import 'ricos-context';

const LinkPreview = ({ settings, componentData }) => {
  return /* @__PURE__ */ React.createElement(
    LinkPreviewViewer,
    {
      settings,
      iframeSandboxDomain: "",
      componentData
    }
  );
};

export { LinkPreview };
//# sourceMappingURL=component.js.map
